import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { AuthService } from './auth.service';

@Injectable()
export class AuthGuardService {
  constructor(private authService: AuthService) {}

  canActivate(route: ActivatedRouteSnapshot): boolean | Promise<boolean> {
    const token = route.queryParams.token;

    if (token) {
      this.authService.checkIfAuthenticated(token);
    }
    return this.authService.isAuthenticated;
  }
}
